import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectCerrarSesionState } from 'selectors/autenticacion.selector';
import { getCerrarSesionWeb } from 'actions/autenticacion.actions';
import logo from 'assets/images/Logo_SIMAC_Mix_.svg';
import { LOGIN_AUTH, SYSTEMS_ROUTE } from 'constants/routeNames';
import { logout } from 'utils/logout';
import { Avatar, Typography, Button } from 'antd';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import './Header.scss';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const NoHoverButton = styled(Button)`
  &:hover {
    color: #ffff !important;
    background-color: inherit !important;
  }
`;

const { Text } = Typography;

export const Header = ({ option }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useSelector((state) => state.validarUsuario);
  const { loading } = useSelector(selectCerrarSesionState);

  const handleLogOut = async () => {
    try {
      const { success } = await dispatch(getCerrarSesionWeb(data.sesion));
      if (success) {
        logout({ redirect: LOGIN_AUTH });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRedirect = () => {
    navigate(SYSTEMS_ROUTE);
  };

  return (
    <div className="contenedorHeader">
      <img src={logo} alt="LogoHeaderSIMAC" style={{ width: 100, height: 60 }} />
      <div className="contenedorInformacionUsuario">
        <Avatar
          size={25}
          style={{ background: '#c12b7d' }}
          icon={<UserOutlined style={{ color: '#FFFF' }} />}
        />
        <Text className="userNameText">{data.name}</Text>
        <Text className="userNameText"> | </Text>
        {option === 'menuSistemas' ? (
          <NoHoverButton
            style={{
              fontSize: '1rem',
              color: '#FFFF',
              width: '35%',
              display: 'flex',
              alignItems: 'center'
            }}
            type="link"
            icon={
              <Avatar
                style={{ border: '2px solid #c12b7d', backgroundColor: '#293846' }}
                size={25}
                icon={<CloseOutlined style={{ color: '#c12b7d' }} />}
              />
            }
            loading={loading}
            onClick={handleLogOut}>
            Cerrar sesión
          </NoHoverButton>
        ) : (
          <NoHoverButton
            style={{
              fontSize: '1rem',
              color: '#FFFF',
              width: '35%',
              display: 'flex',
              alignItems: 'center'
            }}
            type="link"
            icon={
              <Avatar
                style={{ border: '2px solid #c12b7d', backgroundColor: '#293846' }}
                size={25}
                icon={<CloseOutlined style={{ color: '#c12b7d' }} />}
              />
            }
            loading={loading}
            onClick={handleRedirect}>
            Salir
          </NoHoverButton>
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  option: PropTypes.string.isRequired
};
